export function LogoMark({ className, variant = "default" }: { className?: string; variant?: "default" | "inverse" }) {
  const inkColor = variant === "inverse" ? "white" : "var(--color-foreground)";
  return (
    <svg
      viewBox="0 0 32 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`logo-mark ${className ?? ""}`}
      aria-hidden="true"
    >
      <rect x="3" y="0" width="20" height="3" fill="var(--color-primary)" />
      <rect x="3" y="6" width="14" height="3" fill={inkColor} />
      <rect x="3" y="12" width="8" height="3" fill={inkColor} />
    </svg>
  );
}

export function Logo({ className, variant = "default" }: { className?: string; variant?: "default" | "inverse" }) {
  const textColor = variant === "inverse" ? "text-white" : "text-foreground";
  return (
    <span className={`logo flex items-end gap-2 ${className ?? ""}`}>
      <LogoMark className="h-4 w-7" variant={variant} />
      <span className={`logo__wordmark font-heading text-lg font-medium tracking-tight leading-none ${textColor}`}>
        truspecta
      </span>
    </span>
  );
}
